// /* eslint-disable no-unused-expressions */
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import GlobalForm from "../../../components/globalForm/GlobalForm";
// import Loading from "../../../components/shared/loading/Loading";
// import { deleteData } from "../../../hooks/delete";
// import { updateData } from "../../../hooks/update";
// import useFetch from "../../../hooks/useFetch";
// import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
// import BusinessSubsContent from "./BusinessSubsContent";

// const BusinessSubsContentPage = () => {
//   const { homeApi } = apiPath;
//   const { aboutUsBusinessSubsAdd } = RoutePath;
//   const { clientAbout } = clientSideUrl;
//   const [homeSubsidariesData, homeSubsidariesLoading] = useFetch(homeApi);

//   if (homeSubsidariesLoading) {
//     return <Loading />;
//   }
//   async function handleSingleDelete(id, apiId) {
//     const delData = { id: `${id}` };
//     const swalResponse = await Swal.fire({
//       title: "Are you sure you want to delete this?",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       showLoaderOnConfirm: true,
//       preConfirm: async () => {
//         return await deleteData(homeApi, apiId, delData);
//       },
//       allowOutsideClick: () => !Swal.isLoading(),
//     });
//     return swalResponse?.value?.matchedCount > 0;
//   }

//   return (
//     <div className="relative">
//       <div className="mb-4 w-full text-right font-semibold text-sm">
//         <Link
//           className="text-black hover:text-[#DB0029]"
//           to={clientAbout}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Visit page
//           <span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={1.5}
//               stroke="currentColor"
//               className="inline w-4 h-4 ml-1 align-text-top"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
//               />
//             </svg>
//           </span>
//         </Link>
//       </div>
//       <div className="bg-white p-10 shadow-md rounded-md border mt-5">
//         {homeSubsidariesData?.length &&
//           homeSubsidariesData.map(
//             (items) =>
//               items.section_type === "business-subsidaries" &&
//               items.banner_images.map((item) => (
//                 <BusinessSubsContent
//                   key={item._id}
//                   businessSubsData={item}
//                   galleriesLoading={homeSubsidariesLoading}
//                   handleSingleDelete={handleSingleDelete}
//                   apiId={items._id}
//                 />
//               ))
//           )}
//       </div>

//       <div className="fixed bottom-10 right-7 md:right-14">
//         <Link to={`/${aboutUsBusinessSubsAdd}`}>
//           <button
//             title="Add new business-subsidaries"
//             className="p-4 md:p-5 bg-[#DB0029] text-white border-2 border-transparent rounded-full hover:bg-white hover:border-[#DB0029] hover:text-[#DB0029] transition-all duration-100"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={1.5}
//               stroke="currentColor"
//               className="w-5 h-5 md:w-8 md:h-8"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M12 4.5v15m7.5-7.5h-15"
//               />
//             </svg>
//           </button>
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default BusinessSubsContentPage;






/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
import BusinessSubsContent from "./BusinessSubsContent";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { motion } from "framer-motion";

const BusinessSubsContentPage = () => {
  const { homeApi } = apiPath;
  const { aboutUsBusinessSubsAdd, aboutUsBusinessSubs } = RoutePath;
  const { clientAbout } = clientSideUrl;
  const [homeSubsidariesData, homeSubsidariesLoading] = useFetch(homeApi);
  const [subsList, setSubsList] = useState([]);
  const [updatedList, setUpdatedList] = useState(null);

  useEffect(() => {
    const subs = homeSubsidariesData
      ?.find(item => item.section_type === "business-subsidaries")?.banner_images || [];
    setSubsList(subs);
  }, [homeSubsidariesData]);

  async function handleSingleDelete(id, apiId) {
    const delData = { id: `${id}` };
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(homeApi, apiId, delData);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.matchedCount > 0;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMoveImmutable(subsList, oldIndex, newIndex);
    setSubsList(newOrder);
    setUpdatedList(newOrder);
  };

  const updateNewListToDB = () => {
    let apiId = ""
    homeSubsidariesData.map((items) => {
      if (items.section_type === "business-subsidaries") {
        apiId = items._id
      }
    })
    updateData("reorder/business-subs", updatedList, apiId);
    setTimeout(() => {
      setUpdatedList(null);
      window.location.href = "/" + aboutUsBusinessSubs;
    }, 800);
  };

  const DragHandle = SortableHandle(() => (
    <span className="cursor-move text-gray-400">⠿</span>
  ));

  const SortableItem = SortableElement(({ item, apiId }) => (
    <BusinessSubsContent
      key={item._id}
      businessSubsData={item}
      handleSingleDelete={handleSingleDelete}
      apiId={apiId}
      dragHandle={<DragHandle />}
    />
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div className="mt-10">
      {homeSubsidariesData.map(
        (items) =>
          items.section_type === "business-subsidaries" &&
          subsList?.map((item, index) => (
            <SortableItem
              key={item._id}
              index={index}
              item={item}
              apiId={items._id}
            />
          ))
      )}
    </div>
  ));

  if (homeSubsidariesLoading) {
    return <Loading />;
  }

  return (
    <div className="relative">
      <div className="mb-4 w-full text-right font-semibold text-sm">
        <div className="flex justify-end items-center gap-4">
          {updatedList && (
            <motion.button
              onClick={updateNewListToDB}
              type="button"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="btn border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:bg-[#DB0029] px-3 py-1.5 rounded-xl"
            >
              Save Changes
            </motion.button>
          )}
          <Link
            className="text-black hover:text-[#DB0029]"
            to={clientAbout}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit page
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="inline w-4 h-4 ml-1 align-text-top"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </span>
          </Link>
        </div>
      </div>

      <SortableList items={subsList} onSortEnd={onSortEnd} axis="y" useDragHandle />

      <div className="fixed bottom-10 right-7 md:right-14">
        <Link to={`/${aboutUsBusinessSubsAdd}`}>
          <button
            title="Add new business-subsidaries"
            className="p-4 md:p-5 bg-[#DB0029] text-white border-2 border-transparent rounded-full hover:bg-white hover:border-[#DB0029] hover:text-[#DB0029] transition-all duration-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 md:w-8 md:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default BusinessSubsContentPage;
